export default Object.freeze([
	{ label: 'Only when required', value: 'LineItems' },
	{ label: 'Always', value: 'All' },
]);
